import {
  ChangeDetectorRef,
  Component,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {
  DealerRequestModel,
  DealerViewModel,
} from '../../../business-entities/dealer-view-model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { MechanicService } from '../../../business-services/mechanic.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { MechanicList } from '../../../business-entities/mechanicList-model';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import {
  TotalSoldHoursRequestModel,
  TotalSoldHoursReportModel,
  TotalSoldHoursResponseModel,
} from '../../../business-entities/total-sold-hours-report-model';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
@Component({
  selector: 'app-total-sold-hours-report',
  templateUrl: './total-sold-hours-report.component.html',
})
export class TotalSoldHoursReportComponent implements OnInit {
  //#region Properties
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  stampInDate: any[];
  modal: any;

  dealerId: string;
  selectedMechanicName: string;

  scrollDistance = 1;
  throttle = 10;
  totalCount = 0;

  isRequired: boolean;
  isDealerLoggedIn: boolean;
  isStrictBoundries: boolean;

  dealers: DealerViewModel[] = [];
  mechanicList: MechanicList[] = [];
  dealerList: DealerViewModel[] = [];
  totalSoldHoursList: TotalSoldHoursReportModel[] = [];
  totalSoldHoursDetailedList: TotalSoldHoursResponseModel[] = [];
  soldHoursDetailsGridData: TotalSoldHoursResponseModel[] = [];
  selectedMechanics: { id: number }[] = [];
  dataList: TotalSoldHoursReportModel[] = [];

  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  dealerRequestModel: DealerRequestModel = {
    keyLocation: false,
    onlinePayment: false,
    isAdvanceSearch: false,
    statusId: 0,
    isAllDealer: false,
    isForList: false,
  };
  requestModel: TotalSoldHoursRequestModel = {
    dealerId: '',
    mechanicIds: '',
    sortColumn: '',
    sortDirection: '',
    dateRange: '',
    isIncludeAll: false,
  };
  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    maxHeight: 500,
  };
  //#endregion

  //#region Constructor
  constructor(
    public mechanicService: MechanicService,
    private datePipe: DatePipe,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private userService: UserDataService,
    private excelService: ExcelService,
  ) { }
  //#endregion

  //#region Getters
  public get selectedDealerName(): string {
    return this.dealerId ? this.dealerList.filter(x => x.dealerId === this.dealerId)[0].name : '';
  }
  //#endregion

  //#region Angular methods
  async ngOnInit(): Promise<void> {
    this.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.setDefaultValues();
    await this.loadInitialData();
  }
  //#endregion

  //#region Change Detection
  public onDateRangeChanged(event) {
    let eventFormatted= this.getFormattedDate(event);
    if (!eventFormatted){
      this.onDateSelectionCleared();
    }
  }

  public async onDealerChanged(value) {
    if (value) {
      await this.selectedDealer(value);
      this.isRequired = false;
    } else {
      this.isRequired = true;
    }
  }

  public async clearSearch() {
    this.onDateSelectionCleared();
    if (!this.isDealerLoggedIn) {
      this.dealerId = null;
      this.mechanicList = [];
    }
    this.isStrictBoundries = false;
    this.selectedMechanics = [];
    this.totalSoldHoursList = [];
  }

  public async onSearchReport() {
    if (this.dealerId) {
      this.isRequired = false;
      this.totalSoldHoursList = [];
      this.totalSoldHoursDetailedList = [];
      await this.getTotalSoldHoursReport();
    } else {
      this.isRequired = true;
    }
  }

  public async onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.requestModel.sortColumn = column;
    this.requestModel.sortDirection = direction;
    this.totalSoldHoursList = [];
    this.totalSoldHoursDetailedList = [];
    this.getTotalSoldHoursReport();
  }

  public showDetailedGrid(content = null, mechanicId: number, selectedSection: string) {
    this.soldHoursDetailsGridData = [];
    this.selectedMechanicName = this.mechanicList.filter(x => x.id === mechanicId)[0].name;
    switch (selectedSection) {
      case 'workFound': {
        this.soldHoursDetailsGridData = this.totalSoldHoursDetailedList.filter(
          (x) => x.mechanicId === mechanicId
        );
        break;
      }
      case 'mechanicApproved': {
        this.soldHoursDetailsGridData = this.totalSoldHoursDetailedList.filter(
          (x) => x.mechanicId === mechanicId && x.isMechanicApproved === 1
        );
        break;
      }
      case 'adminApproved': {
        this.soldHoursDetailsGridData = this.totalSoldHoursDetailedList.filter(
          (x) => x.mechanicId === mechanicId && x.isAdminApproved === 1
        );
        break;
      }
      case 'customerApproved': {
        this.soldHoursDetailsGridData = this.totalSoldHoursDetailedList.filter(
          (x) => x.mechanicId === mechanicId && x.isCustomerApproved === 1
        );
        break;
      }
      case 'cdssApproved': {
        this.soldHoursDetailsGridData = this.totalSoldHoursDetailedList.filter(
          (x) => x.mechanicId === mechanicId && x.isCDSSApproved === 1
        );
        break;
      }
    }
    this.modal = this.modalService.open(content, { size: 'xl', windowClass: 'EditPopup1' })
  }
  //#endregion

  //#region private methods
  private setDefaultValues() {
    this.setLastMonthDates();

    this.isDealerLoggedIn =
      this.userService.currentUserValue?.roleType ===
      Enums.UserRoles.DealerAdmin;
  }

  private async loadInitialData() {
    if (this.isDealerLoggedIn)
      await this.onDealerChanged(this.userService.currentUserValue.defaultDealerId);
    else await this.getAll();
  }

  private async getAll() {
    await this.mechanicService
      .GetDealerList(this.dealerRequestModel)
      .then(async (data) => {
        this.dealerList = data.responseObject;
        for (let value of this.dealerList) {
          this.dealers.push(value);
        }
        if (this.dealerList.length === 1) {
          this.dealerId = this.dealers[0].dealerId;
          await this.getMechanicList(this.dealerId);
        }
      });
  }

  private async getMechanicList(id: string) {
    this.spinner.show();
    await this.mechanicService
      .GetMechanicList(id, Enums.StatusCode.Active)
      .then((response) => {
        if (response.responseCode == Constant.SuccessResponseCode) {
          this.mechanicList = response.responseObject;
          this.selectedMechanics = this.mechanicList;
        }
        this.spinner.hide();
      });
  }

  private onDateSelectionCleared() {
    let warningmsg = this.translate.instant('lblShowingLastMonthData');
    this.toaster.warning(warningmsg);
    this.setLastMonthDates();
    this.cdr.detectChanges();
  }

  private setLastMonthDates() {
    var date = new Date();
    let startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    let formattedStartDate = this.datePipe.transform(startDate, 'dd/MM/yyyy');
    let endDate = new Date();
    let formattedEndDate = this.datePipe.transform(endDate, 'dd/MM/yyyy');    
    this.stampInDate=[];
    this.stampInDate.push(startDate);
    this.stampInDate.push(endDate);
  }

  private async selectedDealer(dealerId) {
    if (this.isDealerLoggedIn) {
      this.dealerId = dealerId;
    }
    this.selectedMechanics = [];
    await this.getMechanicList(this.dealerId);
  }

  private async getTotalSoldHoursReport() {
    let stampInDateFormatted= this.getFormattedDate(this.stampInDate);
    this.spinner.show();

    if (this.stampInDate.length != 0) {
      this.setLastMonthDates();
    }
    this.requestModel.dateRange = this.stampInDate
      ? stampInDateFormatted
      : null;
    this.requestModel.dealerId = this.dealerId;
    this.requestModel.isIncludeAll = !this.isStrictBoundries;
    this.requestModel.mechanicIds = this.selectedMechanics
      .map((x) => x.id)
      .toString();

    await this.mechanicService
      .getTotalSoldHoursReport(this.requestModel)
      .then((result) => {
        if (result.responseCode === Constant.SuccessResponseCode) {
          this.totalSoldHoursList.push(
            ...result.responseObject.totalSoldHoursReportModel
          );
          this.totalSoldHoursDetailedList =
            result.responseObject.totalSoldHoursDetailedModel;
          this.totalCount = this.totalSoldHoursList?.length;
        } else {
          this.totalCount = 0;
          this.totalSoldHoursList = [];
          this.totalSoldHoursDetailedList = [];
        }
        this.spinner.hide();
      })
      .catch((err) => {
        this.toaster.error(this.translate.instant('lblErrorOccured'));
        this.spinner.hide();
      });
  }
  //#endregion

  //#region  Export functionality

  public async exportAsXLSX() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const excelData = this.mapDataForExport();
    this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblTotalSoldHoursReport')}`);
    this.spinner.hide();
  }

  public async exportAsPDF() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const pdfData = this.mapDataForExport();
    const doc = new jsPDF('landscape');
    autoTable(doc, {
      head: [
        [
          { content: this.translate.instant('lblMechanicName'), rowSpan: 2, styles: { halign: 'left', valign: 'middle' } },
          { content: this.translate.instant('lblAppointments'), colSpan: 2, styles: { halign: 'center', } },
          { content: this.translate.instant('lblTotalWorkFound'), colSpan: 3, styles: { halign: 'center' } },
          { content: this.translate.instant('lblCustomerApproved'), colSpan: 3, styles: { halign: 'center' } },
          { content: this.translate.instant('lblAdminApproved'), colSpan: 3, styles: { halign: 'center' } },
          { content: this.translate.instant('lblMechanicApproved'), colSpan: 3, styles: { halign: 'center' } },
          { content: this.translate.instant('lblCdssApproved'), colSpan: 3, styles: { halign: 'center' } }
        ],
        [
          { content: this.translate.instant('lblPlanned'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblUpsell'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblCount'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblHour'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblAmount'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblCount'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblHour'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblAmount'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblCount'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblHour'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblAmount'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblCount'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblHour'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblAmount'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblCount'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblHour'), styles: { fontStyle: 'bold', halign: 'center' } },
          { content: this.translate.instant('lblAmount'), styles: { fontStyle: 'bold', halign: 'center' } },
        ]
      ],
      body: pdfData.map(row => Object.values(row)),
      margin: { top: 3, left: 3, right: 3, bottom: 3 },
      styles: { fontSize: 8 },
      columnStyles: {
        0: { cellWidth: 27 },
        1: { cellWidth: 16 },
        2: { cellWidth: 13 },
        3: { cellWidth: 14 },
        4: { cellWidth: 14 },
        5: { cellWidth: 19 },
        6: { cellWidth: 14 },
        7: { cellWidth: 14 },
        8: { cellWidth: 19 },
        9: { cellWidth: 14 },
        10: { cellWidth: 14 },
        11: { cellWidth: 19 },
        12: { cellWidth: 14 },
        13: { cellWidth: 14 },
        14: { cellWidth: 19 },
        15: { cellWidth: 14 },
        16: { cellWidth: 14 },
        17: { cellWidth: 19 },
        18: { cellWidth: 14 },
        19: { cellWidth: 14 },
        20: { cellWidth: 19 },
      },
      didParseCell: (data) => {
        if (data.section === 'head' && data.row.index === 1) {
          data.cell.height += 2;
        }
        if (data.section === 'body' && data.column.index > 0) {
          data.cell.styles.halign = 'right';
        }
      }
    });
    doc.save(`${this.translate.instant('lblTotalSoldHoursReport')}.pdf`);
    this.spinner.hide();
  }

  private async exportData(): Promise<void> {
   
    if (this.dealerId) {
      this.spinner.show();
      this.isRequired = false;
      this.totalSoldHoursList = [];
      this.totalSoldHoursDetailedList = [];
      await this.getTotalSoldHoursReport();
    } else {
      this.isRequired = true;
      return
    }
    if (!this.totalSoldHoursList||this.totalSoldHoursList.length===0){
      this.toaster.error(this.translate.instant('lblDataNotAvailable'));
      this.dataList = [];
      return;
    }
    this.dataList =this.totalSoldHoursList;
    this.spinner.hide();
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item) => ({
      [this.translate.instant('lblMechanicName')]: item.mechanicName,
      [`${this.translate.instant('lblAppointments')} (${this.translate.instant('lblPlanned')})`]: item.totalAppointmentCount,
      [`${this.translate.instant('lblAppointments')} (${this.translate.instant('lblUpsell')})`]: item.appointmentCount,
      [`${this.translate.instant('lblTotalWorkFound')} (${this.translate.instant('lblCount')})`]: item.workFoundCount,
      [`${this.translate.instant('lblTotalWorkFound')} (${this.translate.instant('lblHour')})`]: item.workFoundHours,
      [`${this.translate.instant('lblTotalWorkFound')} (${this.translate.instant('lblAmount')})`]: item.workFoundCost,
      [`${this.translate.instant('lblCustomerApproved')} (${this.translate.instant('lblCount')})`]: item.customerApprovedCount,
      [`${this.translate.instant('lblCustomerApproved')} (${this.translate.instant('lblHour')})`]: item.customerApprovedHours,
      [`${this.translate.instant('lblCustomerApproved')} (${this.translate.instant('lblAmount')})`]: item.customerApprovedCost,
      [`${this.translate.instant('lblAdminApproved')} (${this.translate.instant('lblCount')})`]: item.adminApprovedCount,
      [`${this.translate.instant('lblAdminApproved')} (${this.translate.instant('lblHour')})`]: item.adminApprovedHours,
      [`${this.translate.instant('lblAdminApproved')} (${this.translate.instant('lblAmount')})`]: item.adminApprovedCost,
      [`${this.translate.instant('lblMechanicApproved')} (${this.translate.instant('lblCount')})`]: item.mechanicApprovedCount,
      [`${this.translate.instant('lblMechanicApproved')} (${this.translate.instant('lblHour')})`]: item.mechanicApprovedHours,
      [`${this.translate.instant('lblMechanicApproved')} (${this.translate.instant('lblAmount')})`]: item.mechanicApprovedCost,
      [`${this.translate.instant('lblCdssApproved')} (${this.translate.instant('lblCount')})`]: item.cdssApprovedCount,
      [`${this.translate.instant('lblCdssApproved')} (${this.translate.instant('lblHour')})`]: item.cdssApprovedHours,
      [`${this.translate.instant('lblCdssApproved')} (${this.translate.instant('lblAmount')})`]: item.cdssApprovedCost,
    }));
  }
  //#endregion

  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}
